import type { PagesLoginSource } from "../types";
import { formatLocalizedString } from "@glide/localization";

export function getDefaultPagesGreeting(
    pagesSource: PagesLoginSource | undefined,
    appTitle: string | undefined
): string {
    const postFix = appTitle !== undefined ? formatLocalizedString("appTitleOptions", [appTitle]) : "";
    if (pagesSource === "modal-sign-up") {
        return formatLocalizedString("signUpWithOptions", [postFix]);
    }
    return formatLocalizedString("logInWithOptions", [postFix]);
}
